import React from 'react';

const LogoSection = ({ updatedClient, data, updateLogo }) => {
    return (
        <div className='row mt-1'>
            <div className='col-3'>Logo :</div>
            {updatedClient.config?.logo && (
                <div className='mr-2'>
                    <img src={updatedClient.config?.logo} alt="Selected"
                        style={{ width: '200px', height: '50px' }} />
                </div>
            )}
            <div>
                <label
                    className="btn btn-secondary btn-no-border-radius btn-primary-shadow pl-5 pr-5">
                    {data.t.read("browse")}
                    <input type="file" style={{ display: "none" }}
                        onChange={(evt) => updateLogo(evt.target.files)} />
                </label>
            </div>
        </div>
    );
};

export default LogoSection;
